import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/ws-creation-success-image.png'


const _withScopeId = n => (_pushScopeId("data-v-fd3f875e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal__inner__body"
}
const _hoisted_2 = { class: "tw-mt-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-items-center tw-gap-1" }, [
  /*#__PURE__*/_createTextVNode(" I accept & agree to the "),
  /*#__PURE__*/_createElementVNode("span", { class: "yellow-text" }, "Terms of Service")
], -1))
const _hoisted_4 = {
  key: 1,
  class: "modal__carousel__content md:!tw-h-[auto] !tw-mt-0"
}
const _hoisted_5 = { class: "onboarding-steps-content__upload tw-gap-8 !tw-h-auto" }
const _hoisted_6 = { class: "uploade-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "next_step_btns" }
const _hoisted_9 = { class: "skip__wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No Image ?", -1))
const _hoisted_11 = {
  key: 2,
  class: "modal__carousel__content md:tw-gap-12 md:!tw-h-full"
}
const _hoisted_12 = { class: "custom__modal__sub__content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_14 = { class: "custom__modal__heading tw-flex tw-flex-col tw-justify-center tw-items-center" }
const _hoisted_15 = { class: "header-title" }
const _hoisted_16 = { class: "tw-ml-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-sub-title" }, " You have successfully created your Property Workstation. ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom__modal__img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Create Workstation"
  })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description explore__desc" }, " Time to unlock your property superpower! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TermsAndCondition = _resolveComponent("TermsAndCondition")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_commonDialog = _resolveComponent("commonDialog")!
  const _component_KnowYourPropertyComponentModal = _resolveComponent("KnowYourPropertyComponentModal")!
  const _component_CreateWorkstationPreviewModal = _resolveComponent("CreateWorkstationPreviewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowPropertyOwnerWS)
      ? (_openBlock(), _createBlock(_component_commonDialog, {
          key: 0,
          HeaderTittle: $setup.currentSelectedTab?.header,
          title: $setup.currentSelectedTab?.title,
          description: $setup.currentSelectedTab?.description,
          onClickBackButton: $setup.onClickBackButton,
          className: ['propertyowner_workstation_modal']
        }, {
          body: _withCtx(() => [
            ($setup.currentSelectedTab?.id == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_TermsAndCondition),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_checkbox, {
                      class: "checkbox__btn",
                      modelValue: $setup.acceptAggreement,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.acceptAggreement) = $event))
                    }, {
                      label: _withCtx(() => [
                        ($setup.acceptAggreement)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              color: "#faa500"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" mdi-check-circle ")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" mdi-circle-outline ")
                              ]),
                              _: 1
                            })),
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_Button, {
                      class: "!tw-w-auto tw-mt-6",
                      label: "NEXT",
                      onClick: $setup.onClickTermAndConditionNext,
                      isActive: $setup.acceptAggreement,
                      isLoading: $setup.isWorkStationCreated
                    }, null, 8, ["onClick", "isActive", "isLoading"])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_file_input, {
                        accept: "image/png, image/jpeg",
                        class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                        "append-inner-icon": "mdi-image-plus",
                        variant: "solo-filled",
                        onChange: $setup.onFileChange,
                        "onClick:clear": $setup.clearImageUrl
                      }, null, 8, ["class", "onChange", "onClick:clear"]),
                      _createVNode(_component_v_img, {
                        class: "uploaded-img",
                        width: 200,
                        "aspect-ratio": "16/9",
                        cover: "",
                        src: $setup.imageUrl
                      }, null, 8, ["src"]),
                      _createVNode(_component_Text, {
                        variant: "p",
                        textAlign: "center",
                        textColor: "rgba(255, 0, 0,0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.fileUploadErrorMsg), 1)
                        ]),
                        _: 1
                      }),
                      _hoisted_7,
                      _createVNode(_component_Text, {
                        variant: "span",
                        textAlign: "center",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Accepted file formats: PNG, JPEG")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_v_btn, {
                        class: "button button-orange w-full traking",
                        disabled: $setup.isContinueDisabled,
                        loading: $setup.isImageUpload,
                        onClick: $setup.onClickSaveImage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" continue ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading", "onClick"]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_v_btn, {
                          class: "skip__btn",
                          variant: "plain",
                          onClick: $setup.onClickSkipForNow,
                          "append-icon": "mdi-chevron-right"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" skip for now ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_v_form, {
                      onSubmit: $setup.onClickContinue,
                      rules: $setup.validation,
                      ref: "tradingNameRef"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          rules: $setup.validation.tradingName,
                          density: "compact",
                          placeholder: "ie. Sparks Buildings",
                          modelValue: $setup.tradingName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.tradingName) = $event)),
                          variant: "outlined",
                          class: "c-input rounded-full"
                        }, null, 8, ["rules", "modelValue"])
                      ]),
                      _: 1
                    }, 8, ["onSubmit", "rules"])
                  ]),
                  _createVNode(_component_v_btn, {
                    class: "button button-orange w-full",
                    disabled: $setup.isContinueNameDisabled,
                    isLoading: $setup.isWorkStationCreated,
                    onClick: $setup.onClickContinue
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" continue ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "isLoading", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_v_stepper, {
              class: "onboard-stepper",
              modelValue: $setup.currentSelectedTab.id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.currentSelectedTab.id) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modelDetails, (step) => {
                      return (_openBlock(), _createBlock(_component_v_stepper_item, {
                        class: _normalizeClass(["onboard-stepper__item", { done: $setup.currentSelectedTab.id > step?.id }]),
                        key: step?.id,
                        title: step?.tab,
                        value: step?.id
                      }, null, 8, ["class", "title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["HeaderTittle", "title", "description", "onClickBackButton"]))
      : _createCommentVNode("", true),
    ($setup.isShowSuccessFullModal)
      ? (_openBlock(), _createBlock(_component_commonDialog, {
          key: 1,
          isShowHeader: false,
          isShowBackButton: false,
          width: "465px",
          "max-width": "100%",
          height: "auto",
          persistent: "",
          className: ['solo-trader__last__step__box', 'workstation_create_modal']
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(" Nice job, "),
                  _createElementVNode("span", _hoisted_16, _toDisplayString($setup.user?.firstName) + ".", 1)
                ]),
                _hoisted_17
              ]),
              _hoisted_18,
              _hoisted_19
            ]),
            _createVNode(_component_v_btn, {
              class: "button button-orange !tw-mt-[16px] rmd:!tw-mt-[24px]",
              size: "large",
              block: "",
              onClick: $setup.onClickPropertyOwnerDashboard
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Explore 🚀 ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.isShowknowpropertyModal)
      ? (_openBlock(), _createBlock(_component_KnowYourPropertyComponentModal, {
          key: 2,
          onOnClickCloseWelcomeModal: $setup.onClickCloseWelcomeModal
        }, null, 8, ["onOnClickCloseWelcomeModal"]))
      : _createCommentVNode("", true),
    ($setup.isShowWSPreviewModal)
      ? (_openBlock(), _createBlock(_component_CreateWorkstationPreviewModal, {
          key: 3,
          onOnClickClosePreviewButton: $setup.onClickClosePreviewButton
        }, null, 8, ["onOnClickClosePreviewButton"]))
      : _createCommentVNode("", true)
  ], 64))
}